import axios from 'axios';
import { HTTP_CONFIGURATION } from '@/infrastructure/utils/constants';

const instance = axios.create({
  baseURL: process.env.VUE_APP_URL_BASE,
  timeout: HTTP_CONFIGURATION.defaultTimeout,
  validateStatus: function (status) {
    return status >= 200 && status <= 500;
  },
});

export const get = async (
  url,
  options = { headers: HTTP_CONFIGURATION.defaultHeaders }
) => {
  const { headers } = options;
  const { data } = await instance({
    headers,
    url,
    method: 'GET',
  });
  return data;
};

export const post = async (
  url,
  payload,
  options = { headers: HTTP_CONFIGURATION.defaultHeaders }
) => {
  const { headers } = options;
  const { data } = await instance({
    headers,
    url,
    method: 'POST',
    data: payload,
  });
  return data;
};

export const put = async (
  url,
  payload,
  options = { headers: HTTP_CONFIGURATION.defaultHeaders }
) => {
  const { headers } = options;
  const { data } = await instance({
    headers,
    url,
    method: 'PUT',
    data: payload,
  });
  return data;
};
